import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Play, ArrowCounterClockwise, ArrowsClockwise } from "@phosphor-icons/react";
import { Heading, Stat, Btn } from "./NKDaily";
import LoadedQuestions from "./LoadedQuestions";

export default function NKLadderAdmin() {
  const [state, setState] = useState(null);
  useEffect(() => {
    const tick = async () => { try { const r = await api.get("/admin/modes/status"); setState(r.data.ladder); } catch { /* */ } };
    tick(); const id = setInterval(tick, 8000); return () => clearInterval(id);
  }, []);

  const startNow = async () => {
    if (!confirm("Force-start the next NK Ladder window NOW?")) return;
    try { await api.post("/ladder/admin/start-now"); toast.success("Ladder started"); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const reset = async () => {
    if (!confirm("Reset the current ladder? Players in it will be kicked.")) return;
    try { await api.post("/ladder/admin/reset"); toast.success("Ladder reset"); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-6">
      <Heading title="NK Ladder" subtitle="Every 30 minutes, 8am–8pm. Gate Question → top 3 climb 15 rungs." />
      {state ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Stat label="State" value={state.state} />
          <Stat label="Round" value={state.current_round ?? "—"} />
          <Stat label="Scheduled for" value={state.scheduled_for ? new Date(state.scheduled_for).toLocaleTimeString() : "—"} mono />
        </div>
      ) : (
        <div className="nk-card p-6 text-center text-nk-mute text-sm">No ladder scheduled right now.</div>
      )}

      <div className="flex flex-wrap gap-2">
        <Btn onClick={startNow} Icon={Play} label="Start now" tone="accent" />
        <Btn onClick={reset} Icon={ArrowCounterClockwise} label="Reset" tone="bad" />
        <Btn onClick={() => window.open("/ladder", "_blank")} Icon={ArrowsClockwise} label="Open live" tone="line" />
      </div>

      <div className="nk-card p-4">
        <p className="eyebrow mb-2">Schedule</p>
        <p className="text-sm text-nk-mute">Default cadence is one ladder every 30 minutes between 8:00 and 20:00 UTC.
        Changing this requires a backend deploy — file a Settings task.</p>
      </div>
      <LoadedQuestions mode="ladder" />
    </div>
  );
}
